import type { SVGProps } from 'react';

const SvgGallery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentcolor">
      <path d="M9 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M19 2h-6c-1.65 0-3 1.35-3 3v1H9C7.35 6 6 7.35 6 9v1H5c-1.65 0-3 1.35-3 3v6c0 .06.01.12.02.17v.02C2.12 20.75 3.41 22 5 22h6c1.65 0 3-1.35 3-3v-1h1c1.65 0 3-1.35 3-3v-1h1c1.65 0 3-1.35 3-3V5c0-1.65-1.35-3-3-3m-8 10c.55 0 1 .45 1 1v2.38l-3.08 1.54-2.61-.87a1 1 0 0 0-.87.12l-1.45.96V13c0-.55.45-1 1-1zm0 8H5c-.39 0-.71-.23-.88-.55l2.03-1.35 2.54.85c.25.08.53.06.76-.05L12 17.62V19c0 .55-.45 1-1 1m5-5c0 .55-.45 1-1 1h-1v-3c0-1.65-1.35-3-3-3H8V9c0-.55.45-1 1-1h6c.55 0 1 .45 1 1zm4-4c0 .55-.45 1-1 1h-1V9c0-1.65-1.35-3-3-3h-3V5c0-.55.45-1 1-1h6c.55 0 1 .45 1 1z" />
    </g>
  </svg>
);
export default SvgGallery;
